export default function(state = [], action){
	if(action.api) {
		return action.payload.data;

  } // END if

  return state;

} // END reducer


// WEBPACK FOOTER //
// ./src/redux/reducers/loginReducer.js